const HocAux = (props) => props.children;
export default HocAux;
